import { type ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { isJwtLive } from '../api';

export default function ParentGuard({ children }: { children: ReactNode }) {
  const token = localStorage.getItem('auth_token');
  return isJwtLive(token) ? <>{children}</> : <Navigate to="/login" replace />;
}
